import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { AudioPlayer } from "@/components/site/AudioPlayer";
import { Story } from "@/components/site/Story";
import { WhyNow } from "@/components/site/WhyNow";
import { Versions } from "@/components/site/Versions";
import { Gratitude } from "@/components/site/Gratitude";
import { SignupForm } from "@/components/site/SignupForm";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    document.title =
      "Shabbat Shalom, America | Jewish-American Gratitude Song for America 250";
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta(
      "description",
      "A Jewish-American song of gratitude celebrating freedom, family memory, Shabbat light, and America's 250th anniversary."
    );
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <AudioPlayer />
        <Story />
        <WhyNow />
        <Versions />
        <Gratitude />
        <SignupForm />
      </main>
      <Footer />
    </>
  );
}
